import axios from 'axios';
import JSCookies from 'js-cookie';
import { redirectToLoginForAuthFailure } from './authCleanup';

const axiosConfig = axios.create({
	baseURL: import.meta.env.VITE_APP_API_URL,
	headers: {
		'Content-Type': 'application/json'
	},
	withCredentials: true
});

// Request interceptor to add token to every request
axiosConfig.interceptors.request.use(
	config => {
		const token = localStorage.getItem('token') || JSCookies.get('token');
		if (token) {
			config.headers.Authorization = `Bearer ${token.trim().replace(/"/g, '')}`;
		}
		return config;
	},
	error => Promise.reject(error)
);

const PROMO_BYPASS_PATHS = ['/promo/'];

axiosConfig.interceptors.response.use(
	response => response,
	error => {
		const requestUrl = error.config?.url || '';
		const isPromoRoute = PROMO_BYPASS_PATHS.some(path => requestUrl.includes(path));
		if (error.response?.status === 401 && !isPromoRoute) {
			redirectToLoginForAuthFailure();
		}
		return Promise.reject(error);
	}
);

// Function to set the Authorization token dynamically
export const setAuthToken = token => {
	if (token) {
		localStorage.setItem('token', token);
		axiosConfig.defaults.headers.Authorization = `Bearer ${token.trim().replace(/"/g, '')}`;
	} else {
		localStorage.removeItem('token');
		delete axiosConfig.defaults.headers.Authorization;
	}
};

// Function to load token from storage on app start
export const loadAuthToken = () => {
	const token = localStorage.getItem('token') || JSCookies.get('token');
	if (token) {
		axiosConfig.defaults.headers.Authorization = `Bearer ${token.trim().replace(/"/g, '')}`;
	}
	return token;
};

// Call this function when the app starts to set the token if it exists
loadAuthToken();

export default axiosConfig;
